import { SettingComponent } from "../../components";

export default function EnumSettingPage() {
  return <SettingComponent.EnumSettingPage />;
}
